/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  Vote4Delegation,
  Vote4DelegationInterface,
} from "../Vote4Delegation";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContract",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "NFTContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "delegateeList",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "delegateeofAccount",
    outputs: [
      {
        internalType: "address",
        name: "delegatee",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "weightOfDelegation",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDelegateeList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLengthOfDelegateeList",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_voter",
        type: "address",
      },
    ],
    name: "getVotable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_delegation",
        type: "address",
      },
    ],
    name: "getVoteOfDelegation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWinningDelegatee",
    outputs: [
      {
        internalType: "address[2]",
        name: "",
        type: "address[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftaddress",
        type: "address",
      },
    ],
    name: "setNFTcontract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVault",
        name: "_vault",
        type: "address",
      },
    ],
    name: "setVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_val",
        type: "bool",
      },
    ],
    name: "setVotingState",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "state",
    outputs: [
      {
        internalType: "enum Vote4Delegation.State",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_weight",
        type: "uint256",
      },
    ],
    name: "transferDelegation",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newDelegatee",
        type: "address",
      },
    ],
    name: "vote4Delegation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "weightOfDelegatee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type Vote4DelegationConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Vote4DelegationConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Vote4Delegation__factory extends ContractFactory {
  constructor(...args: Vote4DelegationConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _nftContract: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Vote4Delegation> {
    return super.deploy(
      _nftContract,
      overrides || {}
    ) as Promise<Vote4Delegation>;
  }
  override getDeployTransaction(
    _nftContract: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_nftContract, overrides || {});
  }
  override attach(address: string): Vote4Delegation {
    return super.attach(address) as Vote4Delegation;
  }
  override connect(signer: Signer): Vote4Delegation__factory {
    return super.connect(signer) as Vote4Delegation__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Vote4DelegationInterface {
    return new utils.Interface(_abi) as Vote4DelegationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Vote4Delegation {
    return new Contract(address, _abi, signerOrProvider) as Vote4Delegation;
  }
}
